module.exports = __webpack_public_path__ + "img/satellite.222e4f55.png";